import { render, staticRenderFns } from "./FlowInvoiceInformationView.vue?vue&type=template&id=72df5812&scoped=true&"
import script from "./FlowInvoiceInformationView.vue?vue&type=script&lang=ts&"
export * from "./FlowInvoiceInformationView.vue?vue&type=script&lang=ts&"
import style0 from "./FlowInvoiceInformationView.vue?vue&type=style&index=0&id=72df5812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df5812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
